import { Link } from "react-router-dom";
import { LifeBuoy, ArrowRight, BookOpen, Mail } from "lucide-react";
import { SUPPORT_TOPICS } from "@/content/legal";
import SEO from "@/components/SEO";

export default function Support() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14"
         data-testid="support-page">
      <SEO
        title="Support: ConfirmPH"
        description="Common ConfirmPH support topics for renters and rental businesses. Booking confirmation help, account questions, and how to reach our team."
        canonical="/support"
      />
      <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
        ConfirmPH · Help
      </p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold mt-2 inline-flex items-center gap-2">
        <LifeBuoy className="w-7 h-7 text-emerald-600" />
        Support
      </h1>
      <p className="text-slate-600 mt-2">
        Browse common topics. If you can't find what you need, see the FAQ or reach out via Contact.
      </p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        {SUPPORT_TOPICS.map((t) => (
          <article key={t.slug}
                    data-testid={`support-card-${t.slug}`}
                    className="rounded-xl border border-slate-200 bg-white p-5 hover:shadow-sm transition-shadow">
            <h3 className="font-display text-lg font-semibold">{t.title}</h3>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">{t.body}</p>
            {t.link && (
              <Link to={t.link}
                     className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-[#1B4332] hover:underline"
                     data-testid={`support-card-link-${t.slug}`}>
                Open <ArrowRight className="w-3 h-3" />
              </Link>
            )}
          </article>
        ))}
      </div>

      <div className="mt-10 grid sm:grid-cols-2 gap-4">
        <Link to="/faq" data-testid="support-link-faq"
              className="rounded-xl border border-slate-200 bg-slate-50 p-5 hover:bg-white transition-colors flex items-center gap-3">
          <BookOpen className="w-5 h-5 text-slate-700" />
          <div>
            <div className="font-medium">FAQ</div>
            <div className="text-xs text-slate-500">Customers, businesses, billing</div>
          </div>
        </Link>
        <Link to="/contact" data-testid="support-link-contact"
              className="rounded-xl border border-slate-200 bg-slate-50 p-5 hover:bg-white transition-colors flex items-center gap-3">
          <Mail className="w-5 h-5 text-slate-700" />
          <div>
            <div className="font-medium">Contact</div>
            <div className="text-xs text-slate-500">Send us a message</div>
          </div>
        </Link>
      </div>
    </div>
  );
}
